import { addSlidesTabIndex } from '@gravity-global/helpers/swiper/add-slides-tab-index';

const caseStudiesListV2Init = () => {
  const mainPattern = document.querySelectorAll('.gg-case-studies-list-v2');
  mainPattern.forEach((module) => {
    const inputAll = module.querySelector('#all');
    const inputs = module.querySelectorAll('input[type="radio"]');
    const labels = module.querySelectorAll('fieldset label');
    let anyChecked = false;

    const swiperNext = module.querySelector('.gg-features-benefits__next-btn > a');
    const swiperPrev = module.querySelector('.gg-features-benefits__prev-btn > a');
    const swipers = module.querySelector('.posts-result');
    const swiperWrapper = module.querySelector('.posts-result__container');
    const articles = module.querySelectorAll('article');
    const filterSearchInput = module.querySelector('#filter-search-id');
    const searchReset = module.querySelector('.gravity-block-filters__search-reset');
    const buttonSwiper = module.querySelector('.gg-features-button-swiper-wrapper');

    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');

    inputs.forEach(input => {
      if (input.checked) {
        anyChecked = true;
        return;
      }
    });
    if (!anyChecked) {
      if(inputAll) {
        inputAll.checked = true;
      }
    }

    swipers.classList.add('swiper-container');
    swiperWrapper.classList.add('swiper-wrapper');
    articles.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });

    const carousel = new window.Swiper(swipers, {
      loop: false,
      centeredSlides: false,
      watchOverflow: true,
      watchSlidesProgress: true,
      slidesPerGroup: 1,
      slidesPerView: 1,
      spaceBetween: 20,
      allowTouchMove: true,
      navigation: {
        prevEl: swiperPrev,
        nextEl: swiperNext,
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 18,
        },
        640: {
          slidesPerView: 2,
        }
      },
      on: {
        init: (swiper) => addSlidesTabIndex(swiper),
        slideChange: (swiper) => addSlidesTabIndex(swiper),
      },
    });
    carousel.init();

    articles.forEach((article, index) => {
      article.classList.add('fade-in-up', `delay-${index}`);
    });

    labels.forEach((label) => {
      label.addEventListener('click', ()=>{
        observeAndAddClasses(swiperWrapper);
      });
    });

    filterSearchInput.addEventListener('input', ()=>{
      observeAndAddClasses(swiperWrapper);
    });

    searchReset.addEventListener('click', ()=>{
      observeAndAddClasses(swiperWrapper);
    });

    document.addEventListener('DOMContentLoaded', ()=>{
      observeAndAddClasses(swiperWrapper);
    });

    function observeAndAddClasses(swiperWrapper) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            let articles2 = module.querySelectorAll('article');
            if(articles2.length <= 3) {
              buttonSwiper.style.opacity = '0';
            }
            else {
              buttonSwiper.style.opacity = '1';
            }
            articles2.forEach((article, index) => {
              article.classList.add('swiper-slide', 'fade-in-up', `delay-${index}`);
            });
            observer.disconnect();
          }
        });
      });
      observer.observe(swiperWrapper, { childList: true });
    }

    const heightModule = module.offsetHeight;
    module.style.minHeight = heightModule + 'px';
  });
}

caseStudiesListV2Init();
